import React from 'react';
import { ArrowsClockwise, DownloadSimple, FileText } from '@phosphor-icons/react';
import { Button } from '../ui/button';
import { DialogFooter } from '../ui/dialog';

const UploadFooter = ({ onCancel, onParse, canParse, parsing }) => (
  <div className="flex justify-between w-full items-center">
    <Button variant="outline" onClick={onCancel}>
      Cancel
    </Button>
    {parsing && (
      <p className="text-xs text-slate-500 hidden sm:block">
        Scanned PDFs use AI OCR — this can take up to a minute for long rosters.
      </p>
    )}
    <Button
      onClick={onParse}
      disabled={!canParse || parsing}
      className="bg-indigo-900 hover:bg-indigo-800"
      data-testid="parse-file-btn"
    >
      {parsing ? (
        <>
          <ArrowsClockwise size={16} className="mr-2 animate-spin" />
          Reading document…
        </>
      ) : (
        <>
          <FileText size={16} className="mr-2" />
          Parse File
        </>
      )}
    </Button>
  </div>
);

const ReviewFooter = ({ onBack, onImport, recordCount, importing }) => (
  <div className="flex justify-between w-full">
    <Button variant="outline" onClick={onBack}>
      Back
    </Button>
    <Button
      onClick={onImport}
      disabled={!recordCount || importing}
      className="bg-indigo-900 hover:bg-indigo-800"
      data-testid="import-btn"
    >
      {importing ? (
        <ArrowsClockwise size={16} className="mr-2 animate-spin" />
      ) : (
        <DownloadSimple size={16} className="mr-2" />
      )}
      Import {recordCount || 0} Records
    </Button>
  </div>
);

const DoneFooter = ({ onClose }) => (
  <Button
    onClick={onClose}
    className="bg-indigo-900 hover:bg-indigo-800"
    data-testid="import-done-btn"
  >
    Done
  </Button>
);

const ImportFooter = ({
  step,
  onCancel,
  onParse,
  onBack,
  onImport,
  onClose,
  canParse,
  parsing,
  recordCount,
  importing,
}) => (
  <DialogFooter>
    {step === 1 && (
      <UploadFooter
        onCancel={onCancel}
        onParse={onParse}
        canParse={canParse}
        parsing={parsing}
      />
    )}
    {step === 2 && (
      <ReviewFooter
        onBack={onBack}
        onImport={onImport}
        recordCount={recordCount}
        importing={importing}
      />
    )}
    {step === 3 && <DoneFooter onClose={onClose} />}
  </DialogFooter>
);

export default ImportFooter;
